module.exports = __webpack_public_path__ + "img/tv.04bf00cb.svg";